import { api } from "./api";

const bankinfoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBankInfos: builder.query({
      query: () => "bankInfo",
      providesTags: ["bankInfo"],
    }),
    addBankInfo: builder.mutation({
      query: (newCategory) => ({
        url: "bankInfo",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["bankInfo"],
    }),
    removeBankInfo: builder.mutation({
      query: (id) => ({
        url: `bankInfo/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["bankInfo"],
    }),
    editBankInfo: builder.mutation({
      query: (editData) => ({
        url: `bankInfo`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["bankInfo"],
    }),
  }),
});

export const {
  useGetBankInfosQuery,
  useAddBankInfoMutation,
  useRemoveBankInfoMutation,
  useEditBankInfoMutation,
} = bankinfoApi;